import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Tag, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const DISMISS_KEY = 'mg_promo_bar_dismissed';
export const PROMO_CODE = '10%OFF';

export default function AnnouncementBar() {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === '1'
  );
  const navigate = useNavigate();

  if (dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  const copyCode = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(PROMO_CODE);
      toast.success(`Code ${PROMO_CODE} copied — apply it at checkout`);
    } catch {
      toast.success(`Use code ${PROMO_CODE} at checkout`);
    }
    navigate('/shop');
  };

  return (
    <div data-testid="promo-bar" className="relative bg-ink text-bone">
      <div className="mx-auto flex h-10 max-w-7xl items-center justify-center gap-2 px-10 sm:gap-3">
        <Tag className="h-3 w-3 shrink-0 text-gold" />
        <button
          data-testid="promo-shop-link"
          onClick={() => navigate('/shop')}
          className="group flex min-w-0 items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] transition-colors hover:text-gold sm:text-[11px]"
        >
          <span className="hidden text-gold sm:inline">Limited-Time Offer</span>
          <span className="hidden text-bone/50 sm:inline">·</span>
          <span className="truncate">10% off orders $60+</span>
          <span className="hidden text-bone/50 md:inline">· Limited time only</span>
          <ArrowRight className="h-3 w-3 shrink-0 transition-transform group-hover:translate-x-0.5" />
        </button>
        <button
          data-testid="promo-code-copy-button"
          onClick={copyCode}
          aria-label={`Copy promo code ${PROMO_CODE}`}
          className="shrink-0 animate-pulse border border-gold/60 bg-gold/10 px-2 py-0.5 text-[10px] font-bold tracking-[0.15em] text-gold transition-colors hover:bg-gold hover:text-ink sm:text-[11px]"
        >
          CODE: {PROMO_CODE}
        </button>
      </div>
      <button
        data-testid="promo-dismiss-button"
        onClick={dismiss}
        aria-label="Dismiss offer"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-bone/50 transition-colors hover:text-bone"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
